import { Button, Icon, Text } from "@chakra-ui/react";
import { TbEye, TbLock } from "react-icons/tb";
import { useTranslation } from "react-i18next";
import useThemeColors from "../../../../../hooks/useThemeColors";
import {
  backgroundLight,
  primaryAlt,
  textSecondary,
} from "../../../../../utils/colors";
import { Flex, Heading } from "@chakra-ui/react";
import { Link } from "react-router-dom";

const PatientPortal = ({ slug, patient }) => {
  const { t } = useTranslation();
  const { whiteMode, backgroundLightMode, textPrimaryMode, newBorderMode } =
    useThemeColors();

  const plansPublicAvailable =
    patient?.treatmentPlans?.filter((plan) => plan.availablePublic) || [];

  return (
    <>
      <Flex
        direction="column"
        w="100%"
        p={["0rem 1.5rem", "0rem"]}
        position="relative"
        mb="2rem"
      >
        <Flex align="baseline" justify="space-between" m="0.5rem 0 0rem">
          <Heading
            fontSize={["1rem", "1.125rem"]}
            color="primary"
            fontWeight="600"
            m={0}
            // p="0 0 0.75rem"
          >
            {t("patient.patientPortal")}
          </Heading>
        </Flex>

        <Flex
          w="100%"
          bg={whiteMode}
          direction="column"
          m="0.5rem 0 0rem"
          p="1.5rem 1.5rem"
          borderRadius="1rem"
          border={`1px solid ${newBorderMode}`}
          position="relative"
          h="100%"
        >
          {/* PATIENT PORTAL ACTIVE PLANS */}

          <>
            <Flex align="center" mt={1} mb={4}>
              <Icon
                as={TbEye}
                fontSize="1rem"
                color={textSecondary}
                position="relative"
                top="-1px"
                mr="0.5rem"
              />

              <Text
                color={textSecondary}
                fontSize="0.8rem"
                fontWeight="500"
                lineHeight="1"
              >
                {t("patient.patientPortalActivePlans")}:
              </Text>

              <Text
                as="span"
                fontSize="0.8rem"
                fontWeight="500"
                color={primaryAlt}
                lineHeight="1"
                ml={1}
                maxW="260px"
                isTruncated
                textTransform="lowercase"
              >
                {plansPublicAvailable.length}
              </Text>
            </Flex>

            {/* PATIENT PORTAL PIN CODE */}
            <Flex align="center">
              <Icon
                as={TbLock}
                fontSize="1rem"
                color={textSecondary}
                position="relative"
                top="-1px"
                mr="0.5rem"
              />

              <Text
                color={textSecondary}
                fontSize="0.8rem"
                fontWeight="500"
                lineHeight="1"
              >
                {t("patient.patientPortalPinCode")}:
              </Text>

              <Text
                as="span"
                fontSize="0.8rem"
                fontWeight="500"
                color={textSecondary}
                lineHeight="1"
                ml={1}
                maxW="260px"
                isTruncated
              >
                {patient && patient.pinCode ? patient.pinCode : "N/A"}
              </Text>
            </Flex>
          </>
          {/* ) : (
            <Flex align="center" mt={1} mb={4}>
              <Text fontSize="0.8rem" color={textSecondary} fontWeight="500">
                {t("patient.patientHasNoActivePlansSent")}
              </Text>
            </Flex>
          )} */}

          {/* PATIENT PORTAL TEXT */}

          <Flex w="100%" m="1rem 0 0" direction="column">
            {/* <Text
              fontSize="0.8rem"
              color={textSecondary}
              fontWeight="500"
              m="0rem 0 1rem"
            >
              {t("patient.patientPortalDescription", {
                count: patient.treatmentPlans?.length || 0,
              })}
            </Text> */}
            <Flex align="center" w="100%" gap="0.5rem">
              <Link
                to={`/${slug}/portal/patient/${patient._id}`}
                target="_blank"
                style={{
                  width: "100%",
                }}
              >
                <Button
                  size="md"
                  fontSize="0.8rem"
                  bg={backgroundLight}
                  color={textSecondary}
                  w="100%"
                  borderRadius="1rem"
                  _hover={{
                    bg: textPrimaryMode,
                    color: whiteMode,
                  }}
                  //   isDisabled={
                  //     !patient?.treatmentPlans?.length ||
                  //     plansPublicAvailable.length === 0
                  //   }
                >
                  {t("patient.patientPortalButtonLabel")}
                </Button>
              </Link>
              {/* <Button
                size="md"
                fontSize="0.8rem"
                bg={backgroundLight}
                color={textSecondary}
                borderRadius="1rem"
                _hover={{
                  bg: primaryAlt,
                  color: whiteMode,
                }}
                onClick={() => setSendEmailModalOpen(true)}
              >
                {t("patient.patientPortalSendPlans")}
              </Button> */}
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </>
  );
};

export default PatientPortal;
